/* eslint-disable no-eval */
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import { date } from 'quasar'
import infiniteArray from 'infinite-array'
// eslint-disable-next-line no-unused-vars
import NumberUtilsLib from 'utils/NumberUtils'
import momentlib from 'moment'
const { Timestamp } = firebase.firestore
import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Object, String, Array, Number]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  computed: {
    isShow() {
      return this.config.show ? (typeof this.config.show === 'string' ? eval(this.config.show) : this.config.show) : true
    }
  },
  data () {
    return {
      value: this.config.hasOwnProperty('value') ? this.config.value : this.modelProps,
      formatedString: '',
      color: infiniteArray(['teal', 'orange', 'red', 'deep-orange', 'primary', 'black', 'pink']),
      adapterData: {},
      NumberUtils: NumberUtilsLib,
      moment: momentlib
    }
  },
  created () {
    if (this.modelProps instanceof firebase.firestore.Timestamp) {
      this.value = date.formatDate(this.modelProps.toDate(), this.$store.state.config.defaultDateFormat)
    }
    if (typeof this.modelProps === 'number') {
      this.value = Number(this.modelProps).toFixed(2)
    }
    if (this.config.hasOwnProperty('format') && !this.config.chipMode && !Array.isArray(this.value)) {
      // eslint-disable-next-line no-eval
      this.formatedString = eval(this.config.format)
    }
    if (this.config.hasOwnProperty('format') && this.config.chipMode && this.config.hasOwnProperty('adapterData')) {
      this.adapterData = []
      for (let key in this.value) {
        this.adapterData.push(this._.cloneDeep(this.value[key]))
      }
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    formatString (string, item) {
      return eval(string)
    },
    validate () {}
  },
  watch: {
    modelProps: {
      handler: function (newValue) {
        if (this.config.watch) {
          this.value = this._.cloneDeep(newValue)
          if (this.config.hasOwnProperty('format')) {
            // eslint-disable-next-line no-eval
            this.formatedString = eval(this.config.format)
          }
        }
      },
      deep: true
    }
  }
}
